export default String.raw`
{% for file in cart.Attachments -%}
    {% assign type = file.Name | Split: '.' | Last | Downcase -%}
    {% if type == "jfif" or type == "jpe" or type == "jpeg" or type == "jpg" -%}
        {% assign icon = 'file-image' -%}
    {% elseif type == "csv" -%}
        {% assign icon = 'file-csv' -%}
    {% elseif type == "docx" or type == "odt" or type == "doc" -%}
        {% assign icon = 'file-word' -%}
    {% elseif type == "xlsx" or type == "ods" or type == "xls" -%}
        {% assign icon = 'file-spreadsheet' -%}
    {% elseif type == "zip" or type == "rar" or type == "7zip" -%}
        {% assign icon = 'file-archive' -%}
    {% elseif type == "pdf" -%}
        {% assign icon = 'file-pdf' -%}
    {% elseif type == "txt" -%}
        {% assign icon = 'file-alt' -%}
    {% else -%}
        {% assign icon = 'file' -%}
    {% endif -%}
    <div class="cart-message__attachements-item file-container-js">
        <svg class="cart-message__attachements-icon">
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{icon}}-{{settings.iconStyle}}"></use>
        </svg> 
        <span>{{ file.Name }}</span>
        <svg tabindex="0" role="button" class="cart-message__attachements-closer remove-attachement-in-order-js" data-id="{{ file.Id }}">
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
        </svg> 
    </div>
{% endfor -%}
`